import { render } from "./ProductsManager.vue?vue&type=template&id=96067568&scoped=true"
import script from "./ProductsManager.vue?vue&type=script&lang=js"
export * from "./ProductsManager.vue?vue&type=script&lang=js"

import "./ProductsManager.vue?vue&type=style&index=0&id=96067568&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96067568"]])

export default __exports__